// extracted by mini-css-extract-plugin
export default {"Container":"registerCompleted_Container__t-lZG","LoginButton":"registerCompleted_LoginButton__TFKHn"};